import { useCallback, useState } from 'react';
import { Redo, Undo } from '@sas/react-svg';
import { createUseTextLocalizer } from '../../locale/createUseTextLocalizer';
import { postfixTestId } from '../../util/testId';
import { Flow } from '../Layouts/Flow';
import { ContextMenuButton, getUndoRedoProps, useActionManager } from './__internal__';
import bundle from './NovaComponents-UndoRedo-gui-icu.properties';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const useTextLocalizer = createUseTextLocalizer(bundle);
export const UndoRedo = props => {
  const [{
    undoProps,
    redoProps
  }, setUndoRedoProps] = useState(() => getUndoRedoProps(props.actionManager));
  const actionHistoryChangedHandler = useCallback(() => {
    setUndoRedoProps(getUndoRedoProps(props.actionManager));
  }, [props.actionManager]);
  useActionManager(props.actionManager, actionHistoryChangedHandler);
  const localize = useTextLocalizer();
  const undoItems = undoProps.sections[0].items;
  const redoItems = redoProps.sections[0].items;
  const undoTooltip = undoItems.length > 0 ? localize('undoRecent.tooltip.label', {
    item: undoItems[0].text
  }) : undefined;
  const redoTooltip = redoItems.length > 0 ? localize('redoRecent.tooltip.label', {
    item: redoItems[0].text
  }) : undefined;
  return /*#__PURE__*/_jsxs(Flow, {
    spacing: "s",
    children: [/*#__PURE__*/_jsx(ContextMenuButton, {
      testId: postfixTestId(props.testId, 'undoButton'),
      ref: props.undoBtnRef,
      icon: {
        icon: Undo
      },
      tooltip: undoTooltip,
      focusable: props.undoFocusable,
      ...undoProps
    }), /*#__PURE__*/_jsx(ContextMenuButton, {
      testId: postfixTestId(props.testId, 'redoButton'),
      ref: props.redoBtnRef,
      icon: {
        icon: Redo
      },
      tooltip: redoTooltip,
      focusable: props.redoFocusable,
      ...redoProps
    })]
  });
};
//# sourceMappingURL=UndoRedo.js.map